const menuItemsList = [
  {
    key: "/Home",
    title: "Home",
  },
  {
    // key: "/Dashboard",
    id: "CAT_DASHBOARD",
    title: "Dashboard",
    submenu: [
      {
        key: "TicketSummary",
        title: "Ticket Summary",
      },
      {
        key: "AgentKPI",
        title: "Agent KPI",
      },
    ],
  },
  {
    // key: "/AccessManagement",
    id: "CAT_ACCESS_MGMT",
    title: "Access Mgmt.",
    submenu: [
      {
        key: "Users",
        title: "Users",
      },
      {
        key: "Roles",
        title: "Roles",
      },
      {
        key: "Permissions",
        title: "Permissions",
      },
    ],
  },
  {
    // key: "/MasterSetup",
    id:"CAT_MASTER_DATA",
    title: "Master Setup",
    submenu: [
      {
        key: "Policy",
        title: "Policy",
      },
      {
        key: "Organization",
        title: "Organization",
      },
      {
        key: "System",
        title: "System",
      },
      {
        key: "TicketCategory",
        title: "Ticket Category",
      },
      {
        key: "TicketPriorityType",
        title: "Ticket Priority Type",
      },
      {
        key: "TicketStatusType",
        title: "Ticket Status Type",
      },
      {
        key: "ServerEnv",
        title: "Server Environment",
      },
      {
        key: "ServerConnType",
        title: "Server Connection Type",
      },
    ],
  },
  {
    // key: "/Ticket",
    id: "CAT_TICKET",
    title: "Ticket",
    submenu: [
      // {
      //   key: "ViewTicket",
      //   title: "View Ticket",
      // },
      {
        key: "TicketList",
        title: "Ticket List",
      },
      {
        key: "NewTicket",
        title: "New Ticket",
      },
    ],
  },
  {
    // key: "/System_Info",
    id: "CAT_SYSTEM_INFO",
    title: "System Info.",
    submenu: [
      {
        key: "SystemInfo",
        title: "System Info.",
      },
    ],
  },
  {
    id: "CAT_REPORT",
    title: "Report",
    submenu: [
      {
        key: "TicketListHistory",
        title: "Ticket List History",
      },
    ],  
  },
];

export default menuItemsList;
